import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { registerModal } from '@gluedigital/modal'
import { correctPhone } from 'src/util/mix'

import './ClientSupportModal.sass'
import SimpleSupportForm from './SimpleSupportForm'

const ClientSupportModal = () => {
  const user = useSelector((s: any) => s?.user)

  return (
    <div className="modal-content client-support-modal">
      <header>
        <div className="header-content">
          <h1>
            <FormattedMessage id="client-support-modal.title" />
          </h1>
          <h2>
            {user.customerId.includes('SEC')
              ? <span className="special-contact">
                  <FormattedMessage id="client-support-modal.contact-sec" />
                </span>
              : user.customerId.filter(correctPhone).map((customerId) =>
                <a key={customerId} href={`tel:+34${correctPhone(customerId)}`}>
                  <span className="icon icon-tel" />
                  <span>
                    {`${correctPhone(customerId)} - ${customerId}`}
                  </span>
                </a>)}
          </h2>
        </div>
      </header>
      <SimpleSupportForm />
    </div>
  )
}

registerModal('client-support-modal', ClientSupportModal)
